jQuery(document).ready(function($) {
    
        $("#front-contant-form").validate({
            
            focusInvalid: false,
            ignore: ".ignore",
            
            errorPlacement: function(){
                return false;  // suppresses error message text
            },
            submitHandler: function(form){
                form.submit();
            }
        });

        // trim values before validating
        $.each($.validator.methods, function (key, value) {
            $.validator.methods[key] = function () {           
                if(arguments.length > 0) {
                    arguments[0] = $.trim(arguments[0]);
                }
                return value.apply(this, arguments);
            };
        });


        $('#please_call_me').change(function(event) {
        	if( $(this).is(':checked') ){
        		$('#phone-field').rules('add', 'required');
        		$('#phone-field').removeClass('ignore');
        	}else{
        		$('#phone-field').rules('remove', 'required');
        		$('#phone-field').removeClass('error').addClass('ignore');
        	}
        });


        $('#brochure').change(function(event) {
        	if( $(this).is(':checked') ){
        		$('#zip-field').rules('add', 'required');
        		$('#city-field').rules('add', 'required');
        		$('#street-field').rules('add', 'required');

        		$('#number_of_brochures').rules('add', 'required');
        		$('.number_of_brochures_container').slideDown();

        		$('#zip-field, #city-field, #street-field, #number_of_brochures').removeClass('ignore');
        	}else{
        		$('#zip-field').rules('remove', 'required');
        		$('#city-field').rules('remove', 'required');
        		$('#street-field').rules('remove', 'required');

        		$('#number_of_brochures').rules('remove', 'required');
        		$('.number_of_brochures_container').slideUp();

        		$('#zip-field, #city-field, #street-field, #number_of_brochures').removeClass('error').addClass('ignore');
        	}
        });
        
        $('#number_of_brochures').blur(function(event) {
        	if( $(this).val() == '' || $(this).val() < 1 ){
        		$(this).val(1);
        		$(this).removeClass('error');
        	}
        });
});